import axios from 'axios'
import { useUserStore } from '@/store/userStore'
import { useTokenManager } from '@/composables/useTokenManager'
import log from '@/utils/useLogger'
import { emitEvent } from '@/utils/EventBus'

export const useApi = (transformResponse?: (data: any) => any, authRequest: boolean = true) => {
  try {
    const userStore = useUserStore()
    const { getValidToken } = useTokenManager()
    
    const instance = axios.create({
      headers: {
        'Content-Type': 'application/json',
      },
      transformResponse: transformResponse ? [transformResponse] : axios.defaults.transformResponse,
    })

    // Request interceptor to handle token validation and refresh
    instance.interceptors.request.use(
      async (config) => {
        if (authRequest) {
          // this means the user is not logged in
          if (!userStore.isLoggedIn || !userStore.token) throw new Error('User is not authenticated')
          
          const token = await getValidToken()
          if (!token) {
            throw new Error('Failed to get valid token')
          }
          
          config.headers.Authorization = `Bearer ${token}`
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        log.error(error, error?.response?.status)
        if (error.response && error.response.status === 401) {
          log.warn('session expired')
          emitEvent('sessionExpired', '')
        }
        return Promise.reject(error)
      },
    )

    return instance
  } catch (error) {
    log.error('Failed to fetch auth session:', error)
    throw error
  }
}
